import type { ReactElement } from 'react';
import { Box, Button, Dialog, DialogTrigger } from '@ff-it/ui';
import { ClipBadge } from 'modules/radio/ClipBadge';
import { RadioClipsDialog } from 'modules/radio/RadioClipsDialog';
import { usePlanMeta, usePlanSettings } from '../state';

const PREVIEW_LIMIT = 3;

export function RadioClipsButton(): ReactElement | null {
  const { plan_strategy } = usePlanMeta();
  const settings = usePlanSettings<'RADIO'>();
  if (plan_strategy !== 'RADIO') return null;
  const { radio_clips } = settings;

  return (
    <Dialog dismissProps={{ outsidePress: false }}>
      <DialogTrigger>
        <Button
          variant="secondary"
          size="sm"
          title="Radio clips"
          aria-label="Radio clips"
          icon={radio_clips.length === 0 ? 'music' : undefined}
        >
          {radio_clips.length > 0 ? (
            <Box as="span" display="inline-flex" alignItems="center" gap="2">
              {radio_clips.slice(0, PREVIEW_LIMIT).map((clip) => (
                <Box key={clip.id} as="span" display="inline-flex" alignItems="center" gap="1">
                  <ClipBadge clip={clip} />
                  <span>{clip.length_seconds}s</span>
                </Box>
              ))}
              {radio_clips.length > PREVIEW_LIMIT && <span>+{radio_clips.length - PREVIEW_LIMIT}</span>}
            </Box>
          ) : (
            'Clips'
          )}
        </Button>
      </DialogTrigger>
      <RadioClipsDialog />
    </Dialog>
  );
}
